import { connect } from 'react-redux';
import AddressValidationComponent from '../../../components/orders-drawer/sections/address-validation';
import Global from '../../../store/global-selectors';
import { validateAddressRequest } from '../../../store/orders/drawer/orders.drawer.actions';
import { mapDispatchToOnClick, mapStateToOpen } from './section-container-helper';
import { emptyArray } from 'ui-components/default-props/empty';

const sectionId = 'address-validation';

const mapStatesToProps = (state) => {
  const fulfillmentPlanIdsInDrawer = Global.selectSelectedOrdersIds(state) || emptyArray;
  const fulfillmentPlans =
    Global.selectEntitiesFulfillmentPlansByIds(state, {
      fulfillmentPlanIds: fulfillmentPlanIdsInDrawer,
    }) || emptyArray;
  const isValidatingAddress = Global.selectOrdersDrawerIsValidatingAddress(state);
  const shipTos = fulfillmentPlans.map((fp) => fp.shipTo);
  return {
    shipTos,
    isValidatingAddress,
    ...mapStateToOpen(state, sectionId),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onValidateAddress: (shipTos) => dispatch(validateAddressRequest(shipTos)),
    ...mapDispatchToOnClick(dispatch, sectionId),
  };
};

export const AddressValidation = connect(mapStatesToProps, mapDispatchToProps)(AddressValidationComponent);
